import { Link } from "react-router-dom";

const LEGAL_LINKS = [
  { to: "/terms-of-service", label: "Terms" },
  { to: "/privacy-policy", label: "Privacy" },
  { to: "/cookie-policy", label: "Cookies" },
  { to: "/contact", label: "Contact" },
];

/**
 * NextRota footer.
 *
 * - `variant="public"` (default): full-width footer for public pages - used on
 *   /login, legal pages, /contact. Sticky to the bottom of the viewport.
 * - `variant="inline"`: compact, hugs the parent - used inside the Login card.
 */
export default function Footer({ variant = "public" }) {
  if (variant === "inline") {
    return (
      <div className="mt-10 pt-6 border-t border-slate-200 text-xs text-[#4B5773] flex flex-wrap justify-between gap-y-2 gap-x-4"
           data-testid="public-footer">
        <span>© {new Date().getFullYear()} NextRota</span>
        <nav className="flex flex-wrap gap-x-4 gap-y-1">
          {LEGAL_LINKS.map(l => (
            <Link key={l.to} to={l.to} className="hover:text-[#2563EB]" data-testid={`footer-link-${l.label.toLowerCase()}`}>
              {l.label}
            </Link>
          ))}
        </nav>
      </div>
    );
  }
  return (
    <footer className="border-t border-slate-200 bg-white" data-testid="public-footer">
      <div className="max-w-5xl mx-auto px-6 py-6 flex flex-col sm:flex-row gap-3 sm:items-center sm:justify-between text-xs text-[#4B5773]">
        <span>© {new Date().getFullYear()} NextRota · workforce planning made simple</span>
        <nav className="flex flex-wrap gap-x-4 gap-y-1">
          {LEGAL_LINKS.map(l => (
            <Link key={l.to} to={l.to} className="hover:text-[#2563EB]" data-testid={`footer-link-${l.label.toLowerCase()}`}>
              {l.label}
            </Link>
          ))}
        </nav>
      </div>
    </footer>
  );
}
